import { makeSerial, GUID, clone, longestCommonSubstring } from 'core/utils';
import { getAlts } from 'src/paraphraser/handlers/api';
import Segment from './segment';
import Wrapper from './wrapper';
import Track from 'src/paraphraser/handlers/track';
import FireStore from '@FireStore';
import format_output from './format_output';
import Logger from 'core/logger/logger';
import WaltCache from './walt_cache';
import ParaModel from 'src/paraphraser/handlers/ParaModel';
import Stats from './Stats';
import { QUILL_SETTINGS } from '../constants';
import { getReduxStore } from 'src/_common/redux/store';
import { handleArticles } from 'core/utils/articlize';
import { getTimeDifference } from 'src/_common/handlers/helper';

// const Firestore = FireStore?.getInstance();

class Output {
  constructor(
    text,
    paraphraser,
    cb,
    temp,
    outputIndex,
    compareObj,
    citationPresent = false,
    flipperModelId = undefined
  ) {
    this.totalSegmentsCount = 0;
    this.breakSegmentsCount = 0;
    this.segmentorModeID = '';
    this.reported = false;
    this.citationPresent = citationPresent;
    this.beamOutput = text;
    this.changeEvents = [];
    this.history = [];
    this.altered = true;
    this.lastCache = {};
    this.outID = GUID();
    this.outputKey = GUID();
    this.segs = [];
    this.paraphraser = paraphraser;
    this.strength = paraphraser ? paraphraser.strength : -1;
    this.fthresh = paraphraser ? paraphraser.fthresh : -1;
    if (temp) {
      this.strength = compareObj?.strength;
      this.fthresh = compareObj?.fthresh;
    }
    this.editLog = {
      metadata: {
        pID: paraphraser ? paraphraser.pID : '',
        outID: this.outID,
        strength: this.strength,
        fthresh: this.fthresh,
        origText: text ? format_output(text) : null,
      },
      edits: [],
      autoflips: null,
    };
    this.flippedSegKeys = {};

    this.compareModeOutputs = {
      0: { modeStrengthArray: [], focusedComparemodeStrength: {} },
      1: { modeStrengthArray: [], focusedComparemodeStrength: {} },
      2: { modeStrengthArray: [], focusedComparemodeStrength: {} },
      3: { modeStrengthArray: [], focusedComparemodeStrength: {} },
      4: { modeStrengthArray: [], focusedComparemodeStrength: {} },
      6: { modeStrengthArray: [], focusedComparemodeStrength: {} },
      7: { modeStrengthArray: [], focusedComparemodeStrength: {} },
      8: { modeStrengthArray: [], focusedComparemodeStrength: {} },
      9: { modeStrengthArray: [], focusedComparemodeStrength: {} },
      10: { modeStrengthArray: [], focusedComparemodeStrength: {} },
    };
    this.initText = text;
    // this.walts = WaltCache.get(this.fthresh + '~' + text);
    // this.flips = WaltCache.getFlips(this.fthresh + '~' + text);
    // Don't remove. code will be used when flipper upgrades.
    this.walts = WaltCache.get(text);
    this.flips = this.filterFlipResult(this.fthresh, text);
    this.flipperModelId = flipperModelId;
    if (this.flips) {
      this.editLog.flips = this.flips.map(x => x.slice(0, 2));
    }
    //console.log(this.walts)
    this.breakPhrases = [];
    this.rated = false;
    this.lastOutputString = '';
    this.templateText = '';
    this.tfidf = null;

    // this.lastWords

    // adding new vars to collect analytical data
    this.thesaurusedCount = 0; // how many times user clicked on thesaurus
    //this.changedWordCount = 0; // how many words changed after applying flipper change
    this.waltedCount = 0; // how many times user selected the single-paraphrase seg/word from thesaurus
    // end of analytical data vars

    if (text === null || text === undefined) {
      return;
    }
    this.origOut = paraphraser && text === paraphraser.origText;
    var spacedPeriods = text.replace(/\./g, ' .');
    this.cap_words = spacedPeriods
      .split(' ')
      .filter(w => {
        return (
          !(ParaModel.stopWords[w.toLowerCase()] !== undefined) &&
          w !== null &&
          w !== undefined &&
          w.length > 0 &&
          w[0] === w[0].toUpperCase()
        );
      })
      .map(w => {
        return w.toLowerCase();
      });

    this.setTempText(text);
    if (outputIndex) this.setText(text, cb);

    //setTimeout(cb, 150)
    this.origText = format_output(text);

    var pID = this.paraphraser ? this.paraphraser.pID : null;
    if (this.origText?.length)
      Track.createdOutput(
        this.strength,
        this.fthresh,
        this.outID,
        pID,
        this.origText,
        this.flipperModelId,
        ParaModel.inputLanguage
      );

    this.focusTimeStart = 0;
    this.focusTime = 0;
    // this.focusTimer = null;
  }

  rate(good) {
    var action = good ? 'thumbsUp' : 'thumbsDown';
    if (this.thumbs !== undefined) {
      if (good === this.thumbs) {
        this.thumbs = undefined;
        action = 'undo ' + action;
      } else {
        action = 'switch to ' + action;
        this.thumbs = good;
      }
    } else {
      this.thumbs = good;
    }

    var rateObj = {
      orig: this.paraphraser.origText,
      fin: this.getOutputString(),
      edits: this.editLog,
      strength: this.strength,
      focus: this.focusTime,
      oID: this.outID,
      thumbAction: action,
    };

    Track.rateOutput(rateObj);
    // ParaModel.update();
    // console.log(action);
  }

  startFocusTimer() {
    // this.focusTimer = setInterval(() => {
    //   if (ParaModel.focusedParaphraser === this.paraphraser) {
    //     this.focusTime += 0.1;
    //   }
    // }, 100);
    this.focusTimeStart = Date.now();
  }

  stopFocusTimer() {
    // clearInterval(this.focusTimer);
    // this.focusTimer = null;
    this.focusTime += getTimeDifference(this.focusTimeStart);
    this.focusTimeStart = 0;
  }

  detectBrowserLanguage() {
    return (
      (navigator.languages && navigator.languages[0]) ||
      navigator.language ||
      navigator.userLanguage
    );
  }

  handleFormattingExceptions(words) {
    for (var i = 0; i < words.length; i++) {
      var word = words[i];
      var pos = word.pos;
      if (pos === 'punct' && i > 0 && words[i - 1].under) {
        words[i - 1].forceNoPostSpace = true;
        word.noPuncShift = true;
      }
      if (i > 0 && words[i].noPrevSpace) {
        words[i - 1].forceNoPostSpace = true;
      }
    }
    return words;
  }

  addChangeListener(func) {
    this.changeEvents.push(func);
  }

  removeChangeListener(func) {
    var i = this.changeEvents.indexOf(func);
    if (i > 0) {
      this.changeEvents.splice(i, 1);
    }
  }

  outputChanged(editlog) {
    this.altered = true;
    this.lastCache = {};
    editlog.time = Date.now();
    this.editLog.edits.push(editlog);
    this.changeEvents.forEach(f => f());
    // Stats.updateStats();
  }

  undo(cb) {
    this.outputChanged({
      action: 'undo',
      time: Date.now(),
    });
    // console.log('UNDO', this.history);
    if (this.history.length > 0) {
      this.outputKey = GUID();
      var hist = this.history.pop();
      if (hist.type === 'keyboard') {
        this.segs = hist['segs'];
      } else if (hist.type === 'thes') {
        if (hist.atype === 'alt') {
          hist.seg.selectAlt(hist.alt, () => {}, true);
        } else {
          hist.seg.selectFiller(hist.alt, () => {}, true);
        }
      }

      if (cb) {
        cb(hist['cpos']);
      }
    }
  }

  saveHistory(editType, v1, v2, v3) {
    if (editType === 'keyboard') {
      this.history.push({
        type: 'keyboard',
        segs: this.segs,
        text: v1,
        cpos: v2,
      });
    } else if (editType === 'thes') {
      this.history.push({
        type: 'thes',
        seg: v1,
        alt: v2,
        atype: v3,
        cpos: -1,
      });
    }

    if (this.history.length > 20) {
      this.history.shift();
    }
  }

  updateText(text, cpos, cb) {
    // if (text.length === 0) {
    //   text = '⠀';
    // }
    //console.log(text)
    ParaModel.saveParaphraserData();
    this.saveHistory('keyboard', text, cpos);
    var bank = { w1: {}, w2: {}, w3: {}, w4: {}, w5: {} };
    this.segs.forEach(s => {
      if (s.pos === 'synth') {
        return;
      }
      var l = s.text.split(' ').length;
      var key = 'w' + l;
      if (bank[key][s.text]) {
        bank[key][s.text].push(s);
      } else {
        bank[key][s.text] = [s];
      }
    });

    //console.log(bank)
    var words = text.split(' ');
    var newSegs = text.split(' ');
    for (var i = 4; i >= 0; i--) {
      var key = 'w' + (i + 1);
      for (var j = 0; j < words.length - i; j++) {
        var range = words.slice(j, j + i + 1).join(' ');
        //console.log(key, range, bank[key], bank[key][range])
        if (bank[key][range] && bank[key][range].length > 0) {
          //console.log(range)
          var seg = bank[key][range].shift();
          for (var k = j; k <= j + i; k++) {
            if (typeof newSegs[k] === 'string') {
              newSegs[k] = seg;
            }
          }
          //console.log(newSegs)
        }
      }
    }
    //console.log(newSegs)

    function onlyUnique(value, index, self) {
      if (typeof value === 'string') {
        return true;
      }
      return self.indexOf(value) === index;
    }

    var i2 = 0;
    var syntheticSegs = newSegs.filter(onlyUnique).map(v => {
      i2 += 1;
      if (typeof v === 'string') {
        return new Segment(
          {
            index: i2,
            ptag: 'synth',
            text: v,
            alts: [],
            dep_phrase: v + '|synth',
          },
          this,
          i2
        );
      } else {
        v.index = i2;
        v.segData.index = i2;
        return v;
      }
    });
    this.outputKey = GUID();
    this.segs = syntheticSegs;
    var editText = newSegs.filter(x => typeof x === 'string').join(' ');
    //console.log(editText)
    this.outputChanged({ action: 'keyEdit', text: editText });

    cb(this.history[this.history.length - 1]);
  }

  hashWords(words) {
    if (!words) {
      return '' + words;
    }
    var str = '';
    words.forEach(w => {
      var obj = JSON.stringify(makeSerial(w, ['seg']));
      str += obj + '|';
    });
    return str;
  }

  getWords(origText) {
    var words = [];
    var index = 0;
    var pOrig = origText ? origText : this.paraphraser.origText;
    var status = FireStore?.getInstance()?.isPremiumUser() ? 'validated' : 'noob';
    var key = pOrig + '|||' + this.segs.map(s => s.text).join(' ') + '|||' + status;
    if (!this.altered && this.lastCache[key]) {
      return this.lastCache[key];
    }
    var firstQuote = true;
    this.segs.forEach(s => {
      var dispTexts = s.text.split(' ');
      var ws = s.depPhrase.split('_');

      // HANDLE EDGE CASES
      var final_seg = ws.pop().split('|');
      var final_dep = final_seg[1];
      var final_word = final_seg[0];
      if (final_word.match(/\w/i)) {
        final_dep = 'unkn';
      }

      var difftext = pOrig.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
      for (var i = 0; i < dispTexts.length; i++) {
        //var items = ws[i].split("|")
        var dtext = dispTexts[i];
        var firstWord = i === 0;
        var dep = final_dep;
        var forceNoPostSpace = s.forceNoPostSpace;

        var noPostChars = ['-', '[', '{'];
        var isNoPostChars = noPostChars.includes(dtext);
        if (isNoPostChars) {
          dep = 'punct';
          forceNoPostSpace = true;
        }

        if (dep === 'quote') {
          if (firstQuote) {
            forceNoPostSpace = true;
          } else {
            dep = 'punct';
          }
          firstQuote = !firstQuote;
        }

        var aposes = ["'", "'"];
        var noPrevSpace = firstWord && aposes.includes(dtext[0]);
        if (dtext === 'na') {
          noPrevSpace = true;
        }

        var subtext = dtext;
        subtext = subtext.replace("'s", '');
        subtext = subtext.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
        var isDiff = !difftext.includes(subtext);

        words.push({
          index: index,
          word: dtext,
          pos: dep,
          seg: s,
          autoflipped: s.autoflipped,
          firstWord: firstWord,
          prefix: false,
          noPrevSpace: noPrevSpace,
          different: isDiff,
          forceNoPostSpace: forceNoPostSpace,
          isLoading: !this.paraphraser.completed,
        });
        index += 1;
      }
    });
    var final = this.handleFormattingExceptions(
      markDiff(
        this.tfidf,
        0,
        pOrig,
        markLongestSubString(pOrig, makeUnderlines(words, this.paraphraser.origText))
      )
    );

    // if(this.hashWords(this.lastWords) !== this.hashWords(final)){
    //     this.lastWords = final
    //     this.outputChanged(final)
    // }

    // this.lastWords = final;
    this.lastCache[key] = final;
    this.altered = false;
    return final;
  }

  loadStatic(text, paraphraser) {
    this.origText = text;
    this.paraphraser = paraphraser;
    this.outID = GUID();
    this.setTemplateText(text);
    this.breakPhrases = [];
    this.rated = false;
    this.lastOutputString = '';
    this.templateText = text;
    this.outputChanged({ action: 'load static', text: 'text' });
  }

  loadExport(output, paraphraser) {
    // this.paraphraser = paraphraser;
    var self_serializable = [
      'segs',
      'paraphraser',
      'history',
      'lastCache',
      // 'changeEvents',
      // 'lastWords',
      'compareModeOutputs',
    ];
    Object.keys(output).forEach(prop => {
      if (self_serializable.includes(prop)) return;
      this[prop] = output[prop];
    });
    this.segs = output.segs.map(seg => {
      var stemplate = new Segment(null);
      stemplate.loadExport(seg, this);
      return stemplate;
    });
  }

  serialize() {
    return makeSerial(this, ['paraphraser', 'changeEvents', 'history', 'lastCache']);
  }

  setTempText(text) {
    this.outputChanged({ action: 'tempText', text: text });
    var i = 0;
    var occs = {};
    this.segs = text.split(' ').map(seg_text => {
      i += 1;
      if (occs[seg_text] === undefined) {
        occs[seg_text] = 0;
      }
      occs[seg_text] += 1;
      return new Segment(
        { text: seg_text, loading: true, key: seg_text + '~' + occs[seg_text] },
        this,
        i
      );
    });
  }

  setTemplateText(text) {
    this.outputChanged({ action: 'templateText', text: text });
    this.templateText = text;
  }

  restore = text => {
    this.setText(this.initText);
  };

  applyFlipsToText(text) {
    let altedText = text;
    let appliedAlts = [];
    const wordSegmentsOfFrozenWordToSKip = [];
    const outputTextSplitterRegEx = /\w+|\s+|[^\s\w]|"|❝|❞|“|“|”|‟+/g;
    // if (ParaModel.applyFlipsBeforeSegment) {
    const quotes = ['"', '❝', '❞', '“', '“', '”', '‟'];
    let textArr = text.match(outputTextSplitterRegEx);
    let quoteSplitSegments = text.split('"');
    let areQuotationsValid = false;
    if (quoteSplitSegments.length % 2 == 0) {
      console.log(
        "From Output: Incorrect opening and closing of quotations in supplied statement. So ignoring 'Paraphrase Quotations' setting"
      );
    } else {
      areQuotationsValid = true;
    }
    let inQuotation = false;
    let fthreshStr =
      this.fthresh !== null && this.fthresh !== undefined
        ? this.fthresh
        : getReduxStore()?.getState()?.pphr?.wordFlipperValue;
    // let beamKey = fthreshStr + '~' + this.initText;
    // Don't remove. Code to be used when flipper upgrades
    let beamKey = this.initText;

    if (WaltCache.flips[beamKey] !== undefined) {
      let waltMap = {};
      // WaltCache.flips[beamKey].forEach(w => {
      //   waltMap[w[0]] = w[1];
      // });
      // Don't remove. Code to be used when flipper upgrades
      this.filterFlipResult(fthreshStr, beamKey).forEach(w => {
        waltMap[w[0]] = w[1];
      });

      let occs = {};
      let altOccs = {};
      let altedTextArr = textArr.map((w, index) => {
        let wLo = w.toLowerCase();
        if (occs[wLo] === undefined) {
          occs[wLo] = 0;
        }
        occs[wLo] += 1;

        if (altOccs[wLo] === undefined) {
          altOccs[wLo] = 0;
        }
        altOccs[wLo] += 1;

        if (quotes.includes(w) && areQuotationsValid) {
          inQuotation = !inQuotation;
          return w;
        }

        if (inQuotation && !QUILL_SETTINGS.ignoreQuotes) {
          // Ignore flip
          return w;
        } else {
          if (wordSegmentsOfFrozenWordToSKip.includes(index)) {
            return w;
          }
          // Apply flip

          // check for freeze word.
          const freezeWords = getReduxStore()?.getState()?.pphr?.freezeWords;
          // check if part of phase
          for (let i = 0; i < freezeWords.length; i += 1) {
            const splittedFrozenWordArrOnSpace = freezeWords[i].trim().split(' ');
            if (textArr[index - 1] && textArr[index - 1] === "'") {
              break;
            }
            // const splittedFrozenWordArrOnRegEx = freezeWords[i].match(outputTextSplitterRegEx);
            if (splittedFrozenWordArrOnSpace.length > 1) {
              let partOfPhrase = true;
              const _wordSegmentsOfFrozenWordToSKip = [];
              let j = 0;
              for (j; j < splittedFrozenWordArrOnSpace.length; j += 1) {
                if (
                  splittedFrozenWordArrOnSpace[j].trim().toLowerCase() !==
                  textArr[index + j].trim().toLowerCase()
                ) {
                  partOfPhrase = false;
                  break;
                } else {
                  _wordSegmentsOfFrozenWordToSKip.push(index + j);
                }
              }
              if (textArr[index + j] && textArr[index + j] === "'") {
                partOfPhrase = false;
              }
              // const isTheWEnded = textArr[index + j] ==='';
              if (partOfPhrase) {
                wordSegmentsOfFrozenWordToSKip = [..._wordSegmentsOfFrozenWordToSKip];
                return w;
              }
            } else {
              let individuallyPresent = true;
              if (
                (textArr[index - 1] && textArr[index - 1] === "'") ||
                splittedFrozenWordArrOnSpace[0].trim().toLowerCase() !==
                  textArr[index].trim().toLowerCase() ||
                (textArr[index + 1] && textArr[index + 1] === "'")
              ) {
                individuallyPresent = false;
              }
              if (individuallyPresent) {
                return w;
              }
            }
          }
          let wKey = wLo + '~' + occs[wLo];
          if (waltMap[wKey] && waltMap[wKey] !== '') {
            let wText = waltMap[wKey];
            if (altOccs[wText] === undefined) {
              altOccs[wText] = 0;
            }
            altOccs[wText] += 1;
            altOccs[wLo] -= 1;
            let altKey = wText + '~' + altOccs[wText];
            this.flippedSegKeys[altKey] = { wKey: wKey, origText: w };

            if (w[0] === w[0].toUpperCase()) {
              wText = wText[0].toUpperCase() + wText.slice(1);
            }
            // appliedAlts.push({orig: w, alt: wText, key: wKey});
            return wText;
          } else {
            return w;
          }
        }
      });
      altedText = altedTextArr.join('');
    }
    return altedText;
  }

  // Don't remove. Code to be used when flipper upgrades

  filterFlipResult(fthresh, text) {
    let fValue = 9;
    if (WaltCache.flips[text] !== undefined) {
      if (fthresh === 3) fValue = 4;
      else if (fthresh === 2) fValue = 7;
      else if (fthresh === 1) fValue = 9;
      else if (fthresh === 0) fValue = 100;

      let filteredArray = WaltCache.flips[text];
      filteredArray = filteredArray.filter(flip => {
        return flip[2] >= fValue;
      });

      return filteredArray;
    }
  }

  setText(text, cb) {
    let altedText = this.applyFlipsToText(text);
    altedText = handleArticles(altedText);
    /* console.log(
      "-----------Flipped Seg keys: --------------",
      this.flippedSegKeys
    ); */
    text = altedText;
    Wrapper.getSegs(text, this.citationPresent, (segs, totalSegments, segmentorModeID) => {
      this.totalSegmentsCount = totalSegments;
      this.segmentorModeID = segmentorModeID;
      var i = 0;
      var occs = {};
      let appliedAltsCursor = 0;
      this.segs = segs.segs.map(seg => {
        var words = seg.text.split(' ');

        words.forEach((w, ind) => {
          let wLo = w.toLowerCase();
          if (occs[wLo] === undefined) {
            occs[wLo] = 0;
          }
          occs[wLo] += 1;

          if (words.length > 1) {
            let altKey = wLo + '~' + occs[wLo];
            if (this.flippedSegKeys[altKey]) {
              /* seg.flippedWordWithinSeg = {
                alted: wLo,
                orig: this.flippedSegKeys[altKey].origText
              }; */
              if (!seg.flippedWordsWithinSeg) seg.flippedWordsWithinSeg = {};
              seg.flippedWordsWithinSeg[wLo + '~~' + ind] = this.flippedSegKeys[altKey].origText;
            }
          }
        });
        /* console.log(
          "--------------after words eval- ",
          seg.flippedWordsWithinSeg
        ); */

        if (words.length === 1) {
          //seg.key = seg.text + "~" + occs[seg.text];
          seg.key = seg.text.toLowerCase() + '~' + occs[seg.text.toLowerCase()];
          if (this.flippedSegKeys[seg.key]) {
            seg.origText = this.flippedSegKeys[seg.key].origText;
            seg.key = this.flippedSegKeys[seg.key].wKey;
          }
        }
        i += 1;
        seg.loading = false;
        return new Segment(seg, this, i);
      });
      this.fixBreaks();
      this.outputChanged({ action: 'setText', text: text });
      if (cb) {
        setTimeout(() => {
          cb();
        }, 0);
      }
      if (window.updater) {
        window.updater();
      }
    });
  }

  charIsCharacter(char) {
    return char.match(/[a-z]/i);
  }

  fixBreaks(newBreak) {
    if (newBreak) this.breakSegmentsCount += 1;
    try {
      var nospacies = [];
      if (newBreak !== undefined) {
        this.breakPhrases.push(newBreak);
      }
      var newSegs = [];
      var occs = {};
      var i = 1;
      this.segs.forEach(seg => {
        if (this.breakPhrases.includes(seg.phrase)) {
          var words = seg.depPhrase.split('_');
          words.forEach((word, eachWordIndex) => {
            var nseg = clone(seg.segData);
            var items = word.split('|');
            nseg.text = items[0];
            nseg.pos = items[1];
            nseg.dep_phrase = word;
            if (occs[nseg.text] === undefined) {
              occs[nseg.text] = 0;
            }
            occs[nseg.text] += 1;
            nseg.key = nseg.text + '~' + occs[nseg.text];

            if (eachWordIndex !== 0) {
              nseg.pre = '';
            }
            if (eachWordIndex !== words.length - 1) {
              nseg.punct = '';
            }
            var subseg = new Segment(nseg, this, i, s => {
              // We're skipping the getalts call for the word present in the profane list
              if (ParaModel.profaneWords[s.text?.toLowerCase()]) {
                s.alts = [];
              } else {
                getAlts({
                  phrase: word,
                }).then(ret => s.setAlts(ret.alts));
              }
            });
            newSegs.push(subseg);
            i += 1;
          });
        } else {
          if (nospacies.includes(seg.text) && newSegs.length > 0) {
            newSegs[i - 1].fixSplit(seg.text);
          } else {
            var serial = seg.serialize();
            var nseg = clone(seg.segData);

            var words2 = nseg.text.split(' ');
            words2.forEach(w => {
              if (occs[w] === undefined) {
                occs[w] = 0;
              }
              occs[w] += 1;
            });

            /*  We don't need to create the new segment every time for each 
                segment which is not in the breakphrase .
                Also there is a bug in the index of the segments so for that fix
                I am changing the value of i
                Need a proper testing. 
              */
            seg.index = i - 1;
            newSegs.push(seg);

            /* Don't remove this 
            if (words2.length === 1) {
              // nseg.key = nseg.text + '~' + occs[nseg.text];
              newSegs.push(seg);
            } else {
              var fseg = new Segment(nseg, this, i);
              fseg.loadExport(serial, this);
              newSegs.push(fseg);
            } */
            i += 1;
          }
        }
      });
      this.segs = newSegs;
    } catch (e) {
      console.log(e);
    }
  }

  getOutputString() {
    if (this.segs === undefined || (this.templateText && this.templateText.length > 0)) {
      return this.templateText;
    }

    var out = '';
    var forceNoPostSpace = false;
    this.segs.forEach(s => {
      var type = s.pos;
      var text = s.text;
      if (type !== 'punct') {
        var space = forceNoPostSpace ? '' : ' ';
        out += space + text;
      } else {
        if (out.length > 0) {
          var space2 = s.forcePrevSpace ? ' ' : '';
          out = out + space2 + text;
        }
      }
      forceNoPostSpace = s.forceNoPostSpace;
    });
    if (out !== '') {
      out = out[0].toUpperCase() + out.substr(1);
    }
    this.lastOutputString = format_output(out);
    return this.lastOutputString;
  }

  clearSegPrompts() {
    this.segs.forEach(seg => {
      seg.closePrompt();
    });
  }
}

function markDiff(tfidf, startDiff, original, words) {
  if (tfidf === null || tfidf === undefined) {
    words.forEach(w => {
      w['tfidf'] = 0.5;
      w['diff'] = startDiff;
    });
    return words;
  }
  var diff = startDiff;
  words.forEach(w => {
    var text = w['word'];
    var ltext = text.toLowerCase();
    var mag = tfidf[ltext] !== undefined ? tfidf[ltext] : 0.5;
    w['tfidf'] = mag;
    if (original.includes(text)) {
      diff += mag;
    } else {
      diff -= mag;
    }
    w['diff'] = diff;
  });

  return words;
}

function chunkSubstr(str, size) {
  const numChunks = Math.ceil(str.length / size);
  const chunks = new Array(numChunks);

  for (let i = 0, o = 0; i < numChunks; ++i, o += size) {
    chunks[i] = str.substr(o, size);
  }

  return chunks;
}

function markLongestSubString(original, words) {
  //original = replaceAll(original.toLowerCase(), ',',' ,');
  original = original.toLowerCase();

  var comp = words.map(w => w.word.toLowerCase()).join(' ');
  var comp2 = comp.slice();
  var original2 = original.slice();
  var lcs = '';
  if (original.length > 2500) {
    var orig_chunks = chunkSubstr(original, 1000);
    var comp_chunks = chunkSubstr(comp, 1000);
    var max_lcs = '';
    for (var i = 0; i < Math.min(orig_chunks.length, comp_chunks.length); i++) {
      var o = orig_chunks[i];
      var c = comp_chunks[i];
      lcs = longestCommonSubstring(o, c).trim();
      if (lcs.length > max_lcs.length) {
        max_lcs = lcs;
      }
    }
    lcs = max_lcs; //longestCommonSubstring(original, comp).trim()
  } else {
    lcs = longestCommonSubstring(original, comp).trim();
  }
  original = original2;
  comp = comp2;
  // @TODO: check log implementation
  // log('lcs', 'original: ', original)
  // log('lcs', 'comp: ', comp)
  // log('lcs', 'lcs: ', lcs)
  var start = comp.indexOf(lcs);
  var end = start + lcs.length;
  if (start === -1) {
    return;
  }
  // @TODO: check log implementation
  // log('lcs', 'start, end: ', start, start + lcs.length);
  var chars = 0;
  words.forEach(w => {
    var wordlen = w.word.length;
    var word_start = chars;
    var word_end = chars + wordlen;
    chars += wordlen;
    // @TODO: check log implementation

    // log('lcs', 'start, end, chars', w.word, start, end, chars);
    if (chars >= start && chars - wordlen <= end) {
      w.inLongestSubstr = true;
      if (start > word_start) {
        w.lcsRightOffset = word_end - start;
        w.inLongestSubstr = false;
        // @TODO: check log implementation
        // log('lcs', 'RIGHT-OFFSET', w.word, word_end - start);
      }
      if (end < word_end) {
        w.inLongestSubstr = false;
        w.lcsLeftOffset = end - word_start;
        // @TODO: check log implementation
        // log('lcs', 'LEFT-OFFSET', w.word, end - word_start);
      }
    }
    chars += 1;
  });

  /* Check the array if there is less than 4 consecutive words marked as longest
    substring than mark them false */

  /* noLongLimit contanis the consecutive words which we have to mark  
    false as they all sum's less then 4 words  */
  let noLongLimit = -1;
  for (let currentIndex = 0; currentIndex < words.length; currentIndex++) {
    if (noLongLimit > 0) {
      noLongLimit -= 1;
      words[currentIndex].inLongestSubstr = false;
      continue;
    }
    if (words[currentIndex].inLongestSubstr) {
      if (checkNumberOfWords(words, currentIndex) >= 4) {
        currentIndex = currentIndex + checkNumberOfWords(words, currentIndex);
      } else {
        noLongLimit = checkNumberOfWords(words, currentIndex);
        words[currentIndex].inLongestSubstr = false;
        noLongLimit -= 1;
      }
    }
  }
  return words;
}

function makeUnderlines(t2, origText) {
  var extreme_stop_words = [
    'a',
    'the',
    'of',
    'on',
    'is',
    'to',
    'with',
    'if',
    'and',
    'by',
    'it',
    'be',
    'are',
    'at',
    'from',
    'as',
  ];
  var t1 = origText
    .replace(/([.?,*+^$[\]\\(){}|-])/g, ' $1')
    .split(' ')
    .map(s => s.toLowerCase());
  var indices = [];
  var occs = {};

  t1.forEach(w => {
    occs[w] = 0;
  });
  for (var i = 0; i < t2.length; i++) {
    var word = t2[i]['word'].toLowerCase();
    var cI = -1;
    if (occs[word]) {
      if (t1.slice(occs[word]).includes(word)) {
        cI = t1.indexOf(word, occs[word]);
      }
    } else if (t1.includes(word)) {
      cI = t1.indexOf(word);
    }
    if (t2[i]['pos'] === 'punct') {
      cI = -1;
    }
    indices.push(cI);
    occs[word] = Math.max(cI + 1, 0);
  }

  // SWEAP RIGHTWARD
  var cIndex = [];
  i = 0;
  var accounted = t2.length;
  var overload_handler = 0;
  while (accounted > 0) {
    overload_handler += 1;
    if (overload_handler > 20000) {
      break;
    }
    var start = indices[i];
    var c = [start, start];
    if (start !== 1) {
      var pos = indices[i];
      var end = i + 1;
      for (var j = end; j < t2.length; j++) {
        var next_num = indices[j];
        if (next_num === -1) continue;
        if (next_num === pos + 1) {
          c[1] = indices[j];
          pos = next_num;
        } else {
          break;
        }
      }
    }

    var d = c[1] - c[0];
    i += d + 1;
    accounted -= d + 1;
    cIndex.push(c);
  }

  var last_max = -1;
  var last_tail = -1;
  var sets = [];
  var k = 0;
  cIndex.forEach(c => {
    var a = c[0];
    var b = c[1];
    if (a === -1) return;
    if (a > last_max) {
      last_max = a;
      last_tail = b;
      return;
    }
    var diff = last_tail - a;
    if (b - a === 0 && diff > 10) return;

    var x = indices.indexOf(last_max);
    var y = indices.indexOf(b);

    if (b - a === 0 && extreme_stop_words.includes(t2[y]['word'])) return;

    var overload = 0;
    while (cIndex[k + 1][0] === -1) {
      overload += 1;
      if (overload > 20000) {
        break;
      }
      y += 1;
      k += 1;
    }

    sets.push([x, y]);
    k += 1;
  });

  for (i = 0; i < t2.length; i++) {
    var under = false;
    for (var r = 0; r < sets.length; r++) {
      var s = sets[r];
      if (i >= s[0] && i <= s[1]) {
        under = true;
      }
    }
    t2[i]['under'] = under;
  }

  return t2;
}

function markDifferent(original, words) {
  var difftext = original.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
  words.forEach(word => {
    var subtext = word.word;
    subtext = subtext.replace("'s", '');
    subtext = subtext.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
    var isDiff = !difftext.includes(subtext);
    word.isDiff = isDiff;
  });
  return words;
}

function checkNumberOfWords(words, i) {
  let longWordCheckIndex = i;
  for (longWordCheckIndex; longWordCheckIndex < words.length; longWordCheckIndex++) {
    if (!words[longWordCheckIndex].inLongestSubstr) return longWordCheckIndex - i;
  }
  return longWordCheckIndex - i;
}

export default Output;
export { markLongestSubString, markDiff, makeUnderlines, markDifferent };
